import type { FloatingBannerItem } from './types'
import { DEFAULT_COLOR_WHITE } from '~/components/page-editor/constants'

export const DEFAULT_FLOATING_BANNER_ITEM: FloatingBannerItem = {
  text: 'Get your ticket now!',
  textSize: 16,
  fontWeight: '700',
  textColor: DEFAULT_COLOR_WHITE,
  textPaddingLeft: 5,
  textPaddingRight: 5,
  leftImage: 'https://cdn.wnhub.io/54162/679234d374e0e4.83151220.svg',
  leftImageMaxHeight: 40,
  rightImage: 'https://cdn.wnhub.io/54155/679232eebc82e0.73492706.svg',
  rightImageMaxHeight: 120,
  hideWhenHasTicket: true,
  hideWhenTicketsSelected: true,
  targetType: 'block',
}
